"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("utils");
var combinePlatformUrl = function (url) { return "".concat((0, utils_1.getPlatformUrl)()).concat(url); };
exports.default = combinePlatformUrl;
